import React from "react";
import { MainErrorComposition } from "@/components/mainComposition";
import NotFound from "@/components/errorPage/notFound";

export default function Error404Page() {
  return (
    <MainErrorComposition mainContentJSX={<NotFound />} errorNum={404} />
  );
}
